<template>
  <div class="pa-4">
    <v-row>
      <v-col>
        <h2>Affiliates Program</h2>
      </v-col>
      <v-col>
        <div class="d-flex align-center justify-end">
          <div>
            <v-btn
              href="/affiliates/Create"
              class="ml-3"
              color="primary"
              depressed
              dark
            >
              <v-icon v-if="!$vuetify.breakpoint.mdAndUp">
                mdi-plus
              </v-icon>
              <div v-else>
                Add Affiliates Program
              </div>
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-container class="pa-0" fluid>
      <v-row class="campaign-card-row">
        <v-col
          v-for="card in cards"
          :key="card"
          :cols="12"
          :sm="4"
          :md="4"
          :lg="3"
          class="px-5"
        >
          <v-card class="form-card">
            <v-row no-gutters>
              <v-col md="2" cols="4" class="campaign-card-icon">
                <v-btn fab icon class="blue lighten-5 ml-2" width="40px">
                  <v-icon :color="card.color">{{ card.icon }}</v-icon>
                </v-btn>
              </v-col>
              <v-col md="10" cols="8">
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-card-title class="text-h5 pb-0" v-text="card.text">
                    </v-card-title>
                  </v-col>
                  <v-col cols="12">
                    <v-row no-gutters>
                      <v-col>
                        <v-card-subtitle
                          class="font-weight-bold pt-0"
                          v-text="card.title"
                        >
                        </v-card-subtitle>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-card class="mt-10 form-card">
      <div>
        <v-tabs class="px-4" v-model="list">
          <v-tab class="d-flex" v-for="tab in tabs" :key="tab" @click="loadAffiliate(tab.name)">
            {{ tab.name }}
          </v-tab>
        </v-tabs>
      </div>
      <v-divider></v-divider>
      <div class="pa-4">
        <v-row
          no-gutters
          :class="$vuetify.breakpoint.smAndUp ? 'mb-5' : 'mb-2'"
        >
          <v-col
            :cols="$vuetify.breakpoint.smAndUp ? '10' : '12'"
            :class="$vuetify.breakpoint.smAndUp ? 'mr-2' : ''"
          >
            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              label="Search affiliates"
              outlined
              dense
              hide-details="auto"
            ></v-text-field>
          </v-col>
          <v-col :class="$vuetify.breakpoint.smAndUp ? '' : 'mt-3'">
            <v-select
              dense
              outlined
              label="Filters"
              hide-details="auto"
            ></v-select>
          </v-col>
        </v-row>
        <v-row :class="$vuetify.breakpoint.smAndUp ? 'ma-0' : ''">
          <v-col :cols="$vuetify.breakpoint.smAndUp ? '' : '12'">
            <div class="align-center">
              <v-checkbox
                class="mx-0 my-1"
                label="Showing 10 of 100 affiliates"
                hide-details="auto"
              >
              </v-checkbox>
            </div>
          </v-col>
          <v-col>
            <div
              v-if="$vuetify.breakpoint.smAndUp"
              class="d-flex align-center justify-end"
            >
              <div>Sort By:</div>
              <div class="w-50">
                <v-select
                  dense
                  outlined
                  class="ml-3 white"
                  label="Date Modified"
                  hide-details="auto"
                ></v-select>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-data-table
          :headers="headers"
          :items="affiliates"
          :search="search"
          :page.sync="page"
          show-select
          hide-default-footer
          @page-count="pageCount = $event"
        >
          <template v-slot:item.name="{ item }">
            <div class="font-weight-regular">{{ item.name }}</div>
            <div class="font-weight-regular email-style">
              {{ item.url }}
            </div>
          </template>
          <template v-slot:item.action="{ item }">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  elevation="2"
                  fab
                  icon
                  color="white"
                  outlined
                  width="40px"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="black">mdi-dots-horizontal</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item link
                   :to="{
                    name: 'affiliates.create',
                    query: { affiliate_id: item.id },
                  }"
                >Edit</v-list-item>
                <v-list-item link @click="archiveAffiliate(item.id)">Archive</v-list-item>
              </v-list>
              <v-divider></v-divider>
              <v-list dense>
                <v-list-item link>
                  <v-icon class="mr-2" color="red">
                    mdi-delete
                  </v-icon>
                  <div style="color:red;">Delete</div>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip :color="getColor(item.status)" dark>
              {{ item.status }}
            </v-chip>
          </template>
          <template v-slot:item.affiliates="{ item }">
            <div class="blue--text">{{ item.affiliates }}</div>
          </template>
        </v-data-table>
        <div class="text-center pt-2">
          <v-pagination v-model="page" :length="pageCount"></v-pagination>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
  import {mapActions} from "vuex";

  export default {
    data: () => ({
      list: null,
      page: 1,
      pageCount: 0,
      projectPerPage: 10,
      status: null,
      search: null,
      tabs: [{ name: "All" }, { name: "Active" }, { name: "Archive" }],
      cards: [
        {
          title: "Paid Earnings",
          icon: "mdi-currency-usd",
          text: "RM 9,394.90",
          color: "green",
        },
        {
          title: "Unpaid Referrals",
          icon: "mdi-currency-usd",
          text: "RM 1,322.40",
          color: "gray",
        },
        {
          title: "Unpaid Earnings",
          icon: "mdi-currency-usd",
          text: "RM 4,322.00",
          color: "gray",
        },
        {
          title: "Affiliates Program",
          icon: "mdi-share-variant",
          text: "3",
          color: "blue",
        },
      ],
      headers: [
        {
          text: "Name",
          align: "start",
          value: "name",
        },
        { text: "Status", value: "status", width: "7%" },
        { text: "Paid earnings", value: "paid_earning", width: "13%" },
        { text: "Unpaid earnings", value: "unpaid_earning", width: "13%" },
        { text: "Rate", value: "rate", width: "7%" },
        {
          text: "Affiliates",
          value: "affiliates",
          sortable: false,
          width: "5%",
        },
        { text: "Visits", value: "visits", sortable: false, width: "5%" },
        { text: "Action", value: "action", sortable: false, width: "5%" },
      ],
      affiliates: [],
    }),
    computed: {
      dateRangeText() {
        return this.datePick.join(" - ");
      },
    },
    mounted() {
      this.loadAffiliate()
    },
    methods: {
      ...mapActions("affiliate", ["fetchAffiliates", "updateAffiliateArchive"]),
      loadAffiliate(status = null) {
        let filterObj = {};
        let filter = "";
        this.status = status;
        if (this.status && this.status !== 'All') {
          filterObj.status= this.status;
          filter = "?" + new URLSearchParams(filterObj).toString();
        }
        console.log(filter)

        this.isLoading = true;
        this.fetchAffiliates(filter).then((res) => {
          this.isLoading = false;
          this.affiliates = res.data.affiliates;
          // this.cards.forEach((obj, key) => {
          //   this.cards[key].text = res.data.analytics[obj.name]
          // });

        });
      },
      getColor(status) {
        if (status == "Archived") return "grey";
        else return "green";
      },
      editItem(item) {
        console.log(item)
        this.$router.push('affiliates.create', {query: {}})
      },
      archiveAffiliate(affiliate_id) {
        this.isLoading = true;

        this.updateAffiliateArchive({
            affiliate_id: affiliate_id
          }).then((res) => {
            this.isLoading = false;
            if (res.data.success) {
              this.loadAffiliate()
            }
          });
      }
    },
  };
</script>

<style scoped></style>
